import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectFuelType from './../../components/site/select_fuel_type'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApiResult: state.systemLabelMastersApi,
  selectFuelType: state.searchFormCondition.selectFuelType,
})

const SelectFuelTypeContainer = connect(mapStateToProps, mapDispatchToProps)(SelectFuelType)

export default SelectFuelTypeContainer
